<script>
import { Line } from "vue-chartjs"
import _COLORS from "@/store/_COLORS"

export default {
  extends: Line,
  props: {
    data: Array,
    labels: Array,
    label: String,
    title: String,
    unidade: {
      default: "unidades",
      type: String
    },
    step: {
      default: 0,
      type: Number
    }
  },
  mounted() {
    const COLORS = this.data
      .map(el => {
        return _COLORS[Math.floor(Math.random() * _COLORS.length)]
      })
      .sort(() => {
        return Math.random()
      })

    const FILL = COLORS[Math.floor(Math.random() * COLORS.length)]

    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: this.label.toUpperCase(),
            data: this.data,
            borderColor: FILL + "99",
            backgroundColor: FILL + "4D",
            pointBackgroundColor: FILL,
            lineTension: 0,
            fill: true
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.title.toUpperCase(),
          fontSize: 14
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Valores em " + this.unidade
              },
              ticks: {
                beginAtZero: true,
                stepSize: this.step
              }
            }
          ]
        }
      }
    )
  }
}
</script>
